import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
// 购票
const Ticket = r =>
  require.ensure([], () => r(require('@/components/ticket/ticket')), 'Ticket')
const Once = r =>
  require.ensure([], () => r(require('@/components/ticket/once')), 'Once')
const Period = r =>
  require.ensure([], () => r(require('@/components/ticket/period')), 'Period')
const Exercise = r =>
  require.ensure(
    [],
    () => r(require('@/components/ticket/exercise')),
    'Exercise'
  )
const UseCoupon = r =>
  require.ensure(
    [],
    () => r(require('@/components/ticket/use-coupon')),
    'UseCoupon'
  )
const ShopTips = r =>
  require.ensure(
    [],
    () => r(require('@/components/ticket/shopTip')),
    'ShopTips'
  )
// 购票订单确认
const Confirm = r =>
  require.ensure(
    [],
    () => r(require('@/components/ticket/confirm')),
    'Confirm'
  )
const BuyRenew = r =>
  require.ensure(
    [],
    () => r(require('@/components/ticket/buyRenew')),
    'BuyRenew'
  )

// 我的订单
const Order = r =>
  require.ensure([], () => r(require('@/components/order/order')), 'Order')
const OrderAll = r =>
  require.ensure(
    [],
    () => r(require('@/components/order/orderAll')),
    'OrderAll'
  )
const OrderPay = r =>
  require.ensure(
    [],
    () => r(require('@/components/order/orderPay')),
    'OrderPay'
  )
const OrderRefund = r =>
  require.ensure(
    [],
    () => r(require('@/components/order/orderRefund')),
    'OrderRefund'
  )
const OrderDone = r =>
  require.ensure(
    [],
    () => r(require('@/components/order/orderDone')),
    'OrderDone'
  )
const OrderDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/order/orderDetail')),
    'OrderDetail'
  )
const OrderBill = r =>
  require.ensure(
    [],
    () => r(require('@/components/order/orderBill')),
    'OrderBill'
  )
// 活动核销码
const OrderVerify = r =>
  require.ensure(
    [],
    () => r(require('@/components/verify/orderVerify')),
    'OrderVerify'
  )
const VerifyCode = r =>
  require.ensure(
    [],
    () => r(require('@/components/verify/verifyCode')),
    'VerifyCode'
  )
// 我的卡券
const Coupon = r =>
  require.ensure([], () => r(require('@/components/coupon/coupon')), 'Coupon')
const GiftCoupon = r =>
  require.ensure(
    [],
    () => r(require('@/components/coupon/giftCoupon')),
    'GiftCoupon'
  )
const CashCoupon = r =>
  require.ensure(
    [],
    () => r(require('@/components/coupon/cashCoupon')),
    'CashCoupon'
  )
const CourseCoupon = r =>
  require.ensure(
    [],
    () => r(require('@/components/coupon/courseCoupon')),
    'CourseCoupon'
  )
const CouponDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/coupon/couponDetail')),
    'CouponDetail'
  )
const GetCoupon = r =>
  require.ensure(
    [],
    () => r(require('@/components/coupon/getCoupon')),
    'GetCoupon'
  )
// 我的活动
const Activity = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/activity')),
    'Activity'
  )
const Verify = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/verify')),
    'Verify'
  )
const ActivityDone = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/done')),
    'ActivityDone'
  )
const ActivityDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/detail')),
    'ActivityDetail'
  )
// 活动列表
const ActivityList = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/activityList')),
    'ActivityList'
  )
const ActivityListDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/activityDetail')),
    'ActivityListDetail'
  )
const EnterWay = r =>
  require.ensure(
    [],
    () => r(require('@/components/activity/enterWay')),
    'EnterWay'
  )
// 资讯列表
const Information = r =>
  require.ensure(
    [],
    () => r(require('@/components/information/information')),
    'Information'
  )
const InformationDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/information/detail')),
    'InformationDetail'
  )
// 教练列表
const Coach = r =>
  require.ensure([], () => r(require('@/components/coach/coach')), 'Coach')
const CoachGrade = r =>
  require.ensure(
    [],
    () => r(require('@/components/coach/grade')),
    'CoachGrade'
  )
const CoachScore = r =>
  require.ensure(
    [],
    () => r(require('@/components/coach/score')),
    'CoachScore'
  )
const CoachYear = r =>
  require.ensure([], () => r(require('@/components/coach/years')), 'CoachYear')
const CoachLimits = r =>
  require.ensure(
    [],
    () => r(require('@/components/coach/limits')),
    'CoachLimits'
  )
const CoachDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/coach/detail')),
    'CoachDetail'
  )
const Judge = r =>
  require.ensure([], () => r(require('@/components/coach/judge')), 'Judge')
// 会员权益
const Rights = r =>
  require.ensure([], () => r(require('@/components/member/rights')), 'Rights')
const Explain = r =>
  require.ensure(
    [],
    () => r(require('@/components/member/explain')),
    'Explain'
  )
// 个人中心
const Mine = r =>
  require.ensure([], () => r(require('@/components/member/mine')), 'Mine')
// 剩余基础课节
const BaseCourse = r =>
  require.ensure(
    [],
    () => r(require('@/components/member/baseCourse')),
    'BaseCourse'
  )
const CourseCarConsumeRecord = r =>
  require.ensure(
    [],
    () => r(require('@/components/member/courseCarConsumeRecord')),
    'CourseCarConsumeRecord'
  )
// 时段票用时明细
const PeriodDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/member/periodDetail')),
    'PeriodDetail'
  )
// 绑定手机号
const Bind = r =>
  require.ensure([], () => r(require('@/components/bind/bind')), 'Bind')
const Login = r =>
  require.ensure([], () => r(require('@/components/bind/login')), 'Login')
// 个人信息
const UserInfo = r =>
  require.ensure(
    [],
    () => r(require('@/components/user/userInfo')),
    'UserInfo'
  )
const Unregister = r =>
  require.ensure([], () => r(require('@/components/user/unregister')), 'Unregister')
const SetName = r =>
  require.ensure([], () => r(require('@/components/user/setName')), 'SetName')
const SetSchool = r =>
  require.ensure(
    [],
    () => r(require('@/components/user/setSchool')),
    'SetSchool'
  )
const SetBirth = r =>
  require.ensure(
    [],
    () => r(require('@/components/user/setBirth')),
    'SetBirth'
  )
// 错误页面
const Error = r =>
  require.ensure([], () => r(require('@/components/error/error')), 'Error')
// 课程
const Course = r =>
  require.ensure([], () => r(require('@/components/course/course')), 'Course')
const CourseCardDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/courseCardDetail')),
    'CourseCardDetail'
  )
const CoursePackage = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/coursePackage')),
    'CoursePackage'
  )
const PictureInfo = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/pictureInfo')),
    'PictureInfo'
  )
const Experience = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/experience')),
    'Experience'
  )
const ChooseTime = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/chooseTime')),
    'ChooseTime'
  )
const ChooseCoach = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/chooseCoach')),
    'ChooseCoach'
  )
const ConfirmOrder = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/confirmOrder')),
    'ConfirmOrder'
  )
const OrderStatus = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/orderStatus')),
    'OrderStatus'
  )
const CardTicket = r =>
  require.ensure(
    [],
    () => r(require('@/components/course/cardTicket')),
    'CardTicket'
  )
// 我的课程
const MyCourse = r =>
  require.ensure(
    [],
    () => r(require('@/components/myCourse/course')),
    'MyCourse'
  )
const Open = r =>
  require.ensure([], () => r(require('@/components/myCourse/open')), 'Open')
const NotOpen = r =>
  require.ensure(
    [],
    () => r(require('@/components/myCourse/notopen')),
    'NotOpen'
  )
const CourseDone = r =>
  require.ensure(
    [],
    () => r(require('@/components/myCourse/done')),
    'CourseDone'
  )
const CourseTable = r =>
  require.ensure(
    [],
    () => r(require('@/components/myCourse/courseTable')),
    'CourseTable'
  )
// 用时明细
const UseTime = r =>
  require.ensure(
    [],
    () => r(require('@/components/myCourse/useTime')),
    'UseTime'
  )
// 添加支付页面
const Pay = r =>
  require.ensure([], () => r(require('@/components/pay/pay')), 'Pay')
// 我的二维票
const Note = r =>
  require.ensure([], () => r(require('@/components/note/note')), 'Note')
const CourseNote = r =>
  require.ensure(
    [],
    () => r(require('@/components/note/courseNote')),
    'CourseNote'
  )
const OnceNote = r =>
  require.ensure(
    [],
    () => r(require('@/components/note/onceNote')),
    'OnceNote'
  )
const PeriodNote = r =>
  require.ensure(
    [],
    () => r(require('@/components/note/periodNote')),
    'PeriodNote'
  )
const CompanyNote = r =>
  require.ensure(
    [],
    () => r(require('@/components/note/companyNote')),
    'CompanyNote'
  )
const NoteDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/note/noteDetail')),
    'NoteDetail'
  )
// 新活动
const NewActivity = r =>
  require.ensure(
    [],
    () => r(require('@/components/newActivity/detail')),
    'NewActivity'
  )
const NewConfirm = r =>
  require.ensure(
    [],
    () => r(require('@/components/newActivity/confirm')),
    'NewConfirm'
  )
const ShopDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/newActivity/shopDetail')),
    'ShopDetail'
  )
const MyNewActivity = r =>
  require.ensure(
    [],
    () => r(require('@/components/newActivity/myActivity')),
    'MyNewActivity'
  )
const RegisDetail = r =>
  require.ensure(
    [],
    () => r(require('@/components/newActivity/regisDetail')),
    'RegisDetail'
  )
const HtmlWrap = r =>
  require.ensure(
    [],
    () => r(require('@/components/newActivity/htmlwrap')),
    'HtmlWrap'
  )

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
    path: '/',
    name: 'Hello',
    component: Hello
  },
  {
    path: '/ticket',
    name: 'Ticket',
    component: Ticket,
    children: [{
      path: 'once',
      component: Once,
      meta: {
        title: '单次票'
      }
    },
    {
      path: 'period',
      component: Period,
      meta: {
        title: '时段票'
      }
    },
    {
      path: 'exercise',
      component: Exercise,
      meta: {
        title: '练习票'
      }
    }
    ]
  },
  {
    path: '/ticket/buyRenew',
    component: BuyRenew,
    meta: {
      title: '延时续场缴费'
    }
  },
  {
    path: '/useCoupon/:oid',
    name: 'UseCoupon',
    component: UseCoupon,
    meta: {
      title: '使用卡券'
    }
  },
  {
    path: '/shopTips',
    name: 'ShopTips',
    component: ShopTips
  },
  {
    path: '/confirm/:oid/:mid/:type',
    name: 'Confirm',
    component: Confirm,
    mate: {
      title: '订单确认'
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    children: [{
      path: 'all',
      component: OrderAll
    },
    {
      path: 'pay',
      component: OrderPay
    },
    {
      path: 'refund',
      component: OrderRefund
    },
    {
      path: 'done',
      component: OrderDone
    }
    ]
  },
  {
    path: '/order/:oid',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: Coupon,
    children: [{
      path: 'gift',
      component: GiftCoupon
    },
    {
      path: 'course',
      component: CourseCoupon
    },
    {
      path: 'cash',
      component: CashCoupon
    }
    ]
  },
  {
    path: '/couponDetail/:cid',
    name: 'CouponDetail',
    component: CouponDetail
  },
  {
    path: '/getCoupon/:cid',
    name: 'GetCoupon',
    component: GetCoupon
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    children: [{
      path: 'verify',
      component: Verify
    },
    {
      path: 'done',
      component: ActivityDone
    }
    ]
  },
  {
    path: '/activityDetail/:aid',
    name: 'ActivityDetail',
    component: ActivityDetail
  },
  {
    path: '/activityList',
    name: 'ActivityList',
    component: ActivityList,
    meta: {
      title: '活动列表'
    }
  },
  {
    path: '/activityList/:aid',
    name: 'ActivityListDetail',
    component: ActivityListDetail
  },
  {
    path: '/enterWay/:eid',
    name: 'EnterWay',
    component: EnterWay
  },
  {
    path: '/information',
    name: 'Information',
    component: Information
  },
  {
    path: '/information/:iid',
    name: 'InformationDetail',
    component: InformationDetail
  },
  {
    path: '/coach',
    name: 'Coach',
    component: Coach,
    children: [{
      path: 'grade',
      component: CoachGrade
    },
    {
      path: 'score',
      component: CoachScore
    },
    {
      path: 'years',
      component: CoachYear
    },
    {
      path: 'limits',
      component: CoachLimits
    }
    ]
  },
  {
    path: '/coachDetail/:cid',
    name: 'CoachDetail',
    component: CoachDetail
  },
  {
    path: '/judge/:cid',
    name: 'Judge',
    component: Judge
  },
  {
    path: '/rights',
    name: 'Rights',
    component: Rights
  },
  {
    path: '/explain',
    name: 'Explain',
    component: Explain
  },
  {
    path: '/mine',
    name: 'Mine',
    component: Mine
  },
  {
    path: '/baseCourse',
    name: 'BaseCourse',
    component: BaseCourse
  },
    {
      path: '/courseCarConsumeRecord',
      name: 'CourseCarConsumeRecord',
      component: CourseCarConsumeRecord
    },
  {
    path: '/periodDetail/:pid/:left',
    name: 'PeriodDetail',
    component: PeriodDetail
  },
  {
    path: '/bind',
    name: 'Bind',
    component: Bind
  },
  {
    path: '/userInfo',
    name: 'UserInfo',
    component: UserInfo
  },
  {
    path: '/unregister',
    name: 'Unregister',
    component: Unregister
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    path: '/setName',
    name: 'SetName',
    component: SetName
  },
  {
    path: '/setSchool',
    name: 'SetSchool',
    component: SetSchool
  },
  {
    path: '/setBirth',
    name: 'SetBirth',
    component: SetBirth
  },
  {
    path: '/course',
    name: 'Course',
    component: Course
  },
  {
    path: '/courseCardDetail/:id',
    name: 'CourseCardDetail',
    component: CourseCardDetail
  },
  {
    path: '/coursePackage/:cid',
    name: 'CoursePackage',
    component: CoursePackage
  },
  {
    path: '/pictureInfo/:pid',
    name: 'PictureInfo',
    component: PictureInfo
  },
  {
    path: '/experience/:eid',
    name: 'Experience',
    component: Experience
  },
  {
    path: '/chooseTime',
    name: 'ChooseTime',
    component: ChooseTime
  },
  {
    path: '/chooseCoach',
    name: 'ChooseCoach',
    component: ChooseCoach
  },
  {
    path: '/confirmOrder',
    name: 'ConfirmOrder',
    component: ConfirmOrder
  },
  {
    path: '/orderStatus',
    name: 'OrderStatus',
    component: OrderStatus
  },
  {
    path: '/cardTicket',
    name: 'CardTicket',
    component: CardTicket
  },
  {
    path: '/orderBill/:oid',
    name: 'OrderBill',
    component: OrderBill
  },
  {
    path: '/myCourse',
    name: 'MyCourse',
    component: MyCourse,
    children: [{
      path: 'open',
      name: 'Open',
      component: Open,
      meta: {
        title: '我的课程'
      }
    },
    {
      path: 'notOpen',
      name: 'NotOpen',
      component: NotOpen,
      meta: {
        title: '我的课程'
      }
    },
    {
      path: 'done',
      name: 'Done',
      component: CourseDone,
      meta: {
        title: '我的课程'
      }
    }
    ]
  },
  {
    path: '/courseTable/:courseId/:courseMemberId/:courseNum/:courseNumLeft/:courseEndTime',
    name: 'CourseTable',
    component: CourseTable
  },
  {
    path: '/useTime/:uid',
    name: 'UseTime',
    component: UseTime
  },
  {
    path: '/pay/:oid',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/note',
    name: 'Note',
    component: Note,
    children: [{
      path: 'course',
      name: 'Course',
      component: CourseNote
    },
    {
      path: 'once',
      name: 'Once',
      component: OnceNote
    },
    {
      path: 'period',
      name: 'Period',
      component: PeriodNote
    },
    {
      path: 'company',
      name: 'Company',
      component: CompanyNote
    }
    ]
  },
  {
    path: '/noteDetail',
    name: 'NoteDetail',
    component: NoteDetail
  },
  {
    path: '/newActivity/:aid',
    name: 'NewActivity',
    component: NewActivity
  },
  {
    path: '/newConfirm',
    name: 'NewConfirm',
    component: NewConfirm
  },
  {
    path: '/shopDetail/:aid',
    name: 'ShopDetail',
    component: ShopDetail
  },
  {
    path: '/myNewActivity',
    name: 'MyNewActivity',
    component: MyNewActivity
  },
  {
    path: '/regisDetail/:aid/:code',
    name: 'RegisDetail',
    component: RegisDetail
  },
  {
    path: '/htmlwrap/:aid',
    name: 'HtmlWrap',
    component: HtmlWrap
  },
  {
    path: '/orderVerify/:oid/:aid/:eid',
    name: 'OrderVerify',
    component: OrderVerify
  },
  {
    path: '/verifyCode',
    name: 'VerifyCode',
    component: VerifyCode
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/coachDate',
    component: () => import('@/components/course/subscribeCourse/coachDate')
  },
  {
    path: '/subscribeCourse',
    name: 'SubscribeCourse',
    component: () => import('@/components/course/subscribeCourse/subscribeCourse')
  },
  {
    path: '/subscribeExperienceCourse',
    name: 'SubscribeExperienceCourse',
    component: () => import('@/components/course/subscribeCourse/subscribeCourse')
  },
  {
    path: '/subscribeTypes',
    name: 'SubscribeTypes',
    component: () => import('@/components/course/subscribeCourse/subscribeTypes')
  },
  {
    path: '/coachArrange',
    name: 'CoachArrange',
    component: () => import('@/components/course/subscribeCourse/coachArrange')
  },
  {
    path: '/courseInformation',
    name: 'CourseInformation',
    component: () => import('@/components/course/subscribeCourse/courseInformation')
  },
  {
    path: '/subscribedCourse',
    name: 'SubscribedCourse',
    component: () => import('@/components/course/subscribedCourse/subscribedCourse')
  },
  {
    path: '/startedCourse',
    name: 'StartedCourse',
    component: () => import('@/components/course/subscribedCourse/startedCourse')
  },
  {
    path: '/cancelSubscibedCourse',
    component: () => import('@/components/course/subscribedCourse/cancelSubscibedCourse')
  },
  {
    path: '/courseOrderConfirm',
    component: () => import('@/components/course/subscribeCourse/courseOrderConfirm')
  },
  {
    path: '/coursePay',
    component: () => import('@/components/course/subscribeCourse/coursePay')
  },
  {
    path: '/chooseCourse',
    component: () => import('@/components/course/subscribeCourse/chooseCourse')
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js